/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DiscoveryPageDialogTypes {
    ScheduledUpdates = 'ScheduledUpdates',
}
